import {
  testAgentMessage,
  downloadAgentVersionExport,
  validateAgentForTesting,
  generateAgentStats,
  prepareAgentTestData,
} from "./AgentsServices";

// Hook React simplificado para usar com o AgentChat
import { useState, useCallback } from "react";

export const useAgentTesting = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const executeWithLoading = useCallback(async (operation) => {
    setLoading(true);
    setError(null);

    try {
      const result = await operation();
      return result;
    } catch (err) {
      const errorMsg =
        err.response?.data?.detail || err.message || "Erro inesperado";
      setError(errorMsg);
      console.error("Erro na operação:", err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Carregar dados completos do agente para teste
  const loadAgentForTesting = useCallback(
    async (agentId) => {
      return executeWithLoading(async () => {
        const result = await prepareAgentTestData(agentId);

        if (!result.success) {
          throw new Error(result.error);
        }

        return result.data;
      });
    },
    [executeWithLoading]
  );

  // Enviar mensagem de teste
  const sendMessage = useCallback(
    async (agentId, message, options = {}) => {
      return executeWithLoading(async () => {
        const response = await testAgentMessage(agentId, message, options);

        if (response.data.status !== 200) {
          throw new Error(response.data.error || "Erro na resposta do agente");
        }

        return {
          message:
            response.data.data || response.data.message || "Resposta recebida",
          status: response.data.status,
          raw: response.data,
        };
      });
    },
    [executeWithLoading]
  );

  // Exportar e baixar versão
  const exportVersion = useCallback(
    async (agentId, versionNumber = null) => {
      return executeWithLoading(async () => {
        const result = await downloadAgentVersionExport(agentId, versionNumber);

        if (!result.success) {
          throw new Error(result.error);
        }

        return result;
      });
    },
    [executeWithLoading]
  );

  return {
    loading,
    error,
    setError,
    loadAgentForTesting,
    sendMessage,
    exportVersion,
    // Expor funções utilitárias
    service: {
      validateAgentForTesting,
      generateAgentStats,
    },
  };
};

export default useAgentTesting;
